import React from 'react';
import './Button.css';

export default function Button({ children, variant = 'blue', size = 'default', onClick, disabled, style, className = '' }) {
  return (
    <button
      className={`btn btn-${variant} btn-${size} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
}
